export const ADMIN_HOST = "recruitment.mtn.co.rw";

export function currentHost() {
  if (typeof window === "undefined") return "";
  return String(window.location.hostname || "").toLowerCase();
}

export function isAdminHost(hostname = currentHost()) {
  const host = String(hostname || "").toLowerCase();
  if (host === ADMIN_HOST || host === "localhost" || host === "127.0.0.1") return true;
  return /^10\.150\.\d{1,3}\.\d{1,3}$/.test(host);
}

export function isPublicHost(hostname = currentHost()) {
  return !isAdminHost(hostname);
}
